import SuccessLayout from '@shared/components/SuccessLayout';
import BoxContainer from '@shared/components/BoxContainer';

import PassengerInfo from './PassengerInfo';

import FlightItinerary from '@FlightsComponents/FlightItinerary';

import Price from '@FlightsComponents/Price';

import FlightItineraryPDFButton from '../components/FlightItinerary/FlightItineraryPDFButton';

import { useSelector } from 'react-redux';
import SubsidiaryDetails from '@shared/components/SubsidiarySelectorContent/SubsidiaryDetails';

const SummaryContent = ({ datos = {}, pnr = {} }) => {
  const { infoFlightsSearch, flightsInUSD, formReserve, cardData } = datos;

  const pageConfiguration = useSelector(store => store.pageConfiguration);

  return (
    <SuccessLayout>
      <BoxContainer gap={3}>
        <div id="flight-itinerary-pdf" style={{ width: '100%' }}>
          <FlightItinerary
            cluster={pnr?.cluster}
            withEquipment
            baggageIsRow={false}
            baggageBelowContent={false}
            isSuccess
          />
        </div>

        <PassengerInfo
          passengers={formReserve?.passengers}
          email={formReserve?.contactInfo?.email}
        />
      </BoxContainer>

      <BoxContainer>
        <Price
          infoFlightsSearch={infoFlightsSearch}
          cluster={pnr?.cluster}
          isInUSD={flightsInUSD?.isInUSD}
          cardData={cardData}
        />
        {pageConfiguration?.business_types?.code === 'BTC' && (
          <SubsidiaryDetails
            subsidiary={formReserve.selectedSubsidiary}
            withLogo={true}
            imageWidth={140}
          />
        )}
        <FlightItineraryPDFButton cluster={pnr?.cluster} />
      </BoxContainer>
    </SuccessLayout>
  );
};

export default SummaryContent;
